import React from 'react';

const AuthFooter: React.FC = () => (
    <div className="row">
      <div className="col-md-12 text-center">
        {new Date().getFullYear()} &copy; BrokerBay
      </div>
    </div>
  );

export default AuthFooter;
